import axios from "axios";
import { caaryaMeInstance } from ".";

export const subscribeNewsletter = (body) => {
  console.log(body);
  return caaryaMeInstance.post("/subscribe", body);
};
